export enum LabelErrorCode {
    DIAGRAM_IS_USING_LABEL = "DIAGRAM_IS_USING_LABEL",
    ELEMENT_IS_USING_LABEL = "ELEMENT_IS_USING_LABEL",
    CODE_USED_BY_ANOTHER_LABEL = "CODE_USED_BY_ANOTHER_LABEL"
}
